

























import { Component, Vue } from 'vue-property-decorator';
import { ObjectFactory } from '../../config/objectFactory';
import { ModelSelect } from 'vue-search-select';

@Component({
    props: {
        id: String,
    },
    components: {
        ModelSelect,
    },
    data() {
        return {
            fullName: '',
            phone: '',
            checkbox: true,
            checkboxval: false,
        };
    },
    methods: {
        enableDisable() {
            this.$data.checkbox = this.$data.checkboxval;
        },
    },
})
export default class PartnerConfirmationModal extends Vue {
    private show = false;
    private fullname: string = '';
    private phone: string = '';
    private requestId = '';

    public mounted() {
        this.requestId = this.$route.params.id;
        this.show = true;
        this.getRequestDetails();
    }

    private async getRequestDetails() {
        const response = await ObjectFactory.getRequestService().getRequestDetails
        (this.requestId, this.$store.state.serverUrl);
        if (response && response.data) {
            this.$data.fullName = response.data.appointment.patient.fullName;
            this.$data.phone = response.data.appointment.patient.phone;
        }
    }

    private async acceptReq() {
        this.$emit('accept');
    }

    private close() {
        this.$emit('close');
    }
}
